import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { CampoSpecificoFascicoloDTO } from "../dto/campo-specifico-fascicoloDTO";
import { CampoSpecificoFascicoloVO } from "../vo/campo-specificoVO";

@Injectable({
  providedIn: "root",
})
export class MapperCampoSpecificoFascicolo
  implements
    MapperInterface<CampoSpecificoFascicoloDTO, CampoSpecificoFascicoloVO> {
  convertVoToDto(vo: CampoSpecificoFascicoloVO): CampoSpecificoFascicoloDTO {
    if (vo != null) {
      const dto = new CampoSpecificoFascicoloDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.nome = vo.nome;
      dto.valore = vo.valore;
      dto.codice = vo.codice;
      dto.tipoDato = vo.tipoDato;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: CampoSpecificoFascicoloDTO): CampoSpecificoFascicoloVO {
    if (dto != null) {
      const vo = new CampoSpecificoFascicoloVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.nome = dto.nome;
      vo.valore = dto.valore;
      vo.codice = dto.codice;
      vo.tipoDato = dto.tipoDato;

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: CampoSpecificoFascicoloVO[]
  ): CampoSpecificoFascicoloDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: CampoSpecificoFascicoloDTO[]
  ): CampoSpecificoFascicoloVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
